import React, { Component } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { CloseButton } from 'react-bootstrap';
import { actions } from '../helpers/messages';

export default class CustomModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { show, dialogClassName, title, body, hideClose, isConfirm, isAlert, alertDisable=false, isComponent, children, confirmText, rejectText, alertText, confirmAction, rejectAction, closeAction, saveDisable = false, loading } = this.props;
        const dataTestId = this.props['data-testid'];

        return (
            <Modal data-testid="common-modal" id="common-modal" show={show} onHide={closeAction} backdrop="static" keyboard={!hideClose} dialogClassName={dialogClassName}>
                {loading ? <div className="loading-overlay modal-loader"><span>{actions.load}</span></div> : ''}
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                    {hideClose === true ? '' : <CloseButton data-testid={dataTestId} onClick={closeAction} />}
                </Modal.Header>
                <Modal.Body>
                    {!isComponent ?
                        <div className="row">
                            <div className="col-sm-12">{body}</div>
                        </div>
                        : children}
                </Modal.Body>

                {isConfirm ?
                    <Modal.Footer>
                        {loading ? <div className="loading-overlay modal-loader"></div> : ''}
                        <Button variant="primary" id="confirmBtn" disabled={saveDisable} onClick={confirmAction}>{confirmText || 'Yes'}</Button>
                        <Button variant="secondary" id="rejectBtn" onClick={rejectAction}>{rejectText || 'No'}</Button>
                    </Modal.Footer>
                    : ''}

                {isAlert ?
                    <Modal.Footer>
                        <Button variant="primary" disabled={alertDisable} onClick={closeAction}>{alertText || 'Okay'}</Button>
                    </Modal.Footer>
                    : ''}
            </Modal>
        )
    }
}
